import { DesktopLayout } from './DesktopLayout';
import { IntakeManagementPageInitialProps } from '~/data';

type IntakeCreateLayoutProps = Readonly<{
  initialProps: IntakeManagementPageInitialProps;
}>;

export function IntakeCreateLayout({ initialProps }: IntakeCreateLayoutProps) {
  return <DesktopLayout initialProps={initialProps} />;
}
